<template>
  <div class="city_list_box" v-show="show">
    123
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  props: {
    show: {
      show: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="less">
.city_list_box {
  position: absolute;
  width: 245px;
  height: 150px;
  overflow-y: scroll;
  background-color: #fff;
  bottom: -152px;
  box-shadow: 0 2px 2px #eaeaea;
  z-index: 50;
  padding-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/newPages/booking/components/CityList.vue